module.exports = __webpack_public_path__ + "67f459375b6e685c44486206fa75fc72.svg";